import React from 'react'
import {
  TiSocialInstagram,
  TiSocialFacebook,
  TiSocialLinkedin,
  TiSocialYoutube,
} from 'react-icons/ti'
import Lista from './styles'

const RedesSociais = () => (
  <Lista className="social">
    <li>
      <a
        href="https://www.facebook.com/santajoana/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <TiSocialFacebook />
        <span>Facebook</span>
      </a>
    </li>
    <li>
      <a
        href="https://www.instagram.com/hmsantajoana/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <TiSocialInstagram />
        <span>Instagram</span>
      </a>
    </li>
    <li>
      <a
        href="https://www.youtube.com/user/hospitalsantajoanasp"
        target="_blank"
        rel="noopener noreferrer"
      >
        <TiSocialYoutube />
        <span>Youtube</span>
      </a>
    </li>
    <li>
      <a
        href="https://www.linkedin.com/company/grupo-santa-joana/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <TiSocialLinkedin />
        <span>LinkedIn</span>
      </a>
    </li>
  </Lista>
)

export default RedesSociais
